import React, { forwardRef } from "react"
import { useNavigate } from "react-router-dom"
import { AppRoutes } from "../../../consts/appRoutes.consts"
import ContextMenu from "../../../components/atoms/ContextMenu.atom"
import { updateTeamMemberActiveStatus } from "../../../services/teamMember.service"

const TeamMembersContextMenu = forwardRef((props, ref) => {
  const navigate = useNavigate()

  const items = []
  items.push({
    label: "Editar",
    icon: "pi pi-pencil",
    command: () => {
      navigate(AppRoutes.integrantes.editar, {
        state: { ...props.selectedRow },
      })
    },
  })
  if (props.selectedRow?.active === 1) {
    items.push({
      label: "Desactivar",
      icon: "pi pi-ban",
      command: () => {
        props.setOpenModal(true)
      },
    })
  } else if (props.selectedRow?.active === 0) {
    items.push({
      label: "Habilitar",
      icon: "pi pi-check-circle",
      command: async () => {
        await updateTeamMemberActiveStatus({
          userId: props.selectedRow?.userId,
          active: !props.selectedRow?.active,
        })
        props.setRefresh(true)
      },
    })
  }
  return <ContextMenu ref={ref} model={items} />
})

export default TeamMembersContextMenu
